export const COUNTRY_FLAGS = [
    {
        "code": {
            "aplha2code": "AF",
            "alpha3code": "AFG",
            "numericcode": "004"
        },
        "name": {
            "shortname": "AFGHANISTAN",
            "shortnamelowercase": "Afghanistan",
            "fullname": "the Islamic Republic of Afghanistan"
        },
        "flag": {
            "spriteIcon": "af"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AL",
            "alpha3code": "ALB",
            "numericcode": "008"
        },
        "name": {
            "shortname": "ALBANIA",
            "shortnamelowercase": "Albania",
            "fullname": "the Republic of Albania"
        },
        "flag": {
            "spriteIcon": "al"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "DZ",
            "alpha3code": "DZA",
            "numericcode": "012"
        },
        "name": {
            "shortname": "ALGERIA",
            "shortnamelowercase": "Algeria",
            "fullname": "the People's Democratic Republic of Algeria"
        },
        "flag": {
            "spriteIcon": "dz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AS",
            "alpha3code": "ASM",
            "numericcode": "016"
        },
        "name": {
            "shortname": "AMERICAN SAMOA",
            "shortnamelowercase": "American Samoa",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "as"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AD",
            "alpha3code": "AND",
            "numericcode": "020"
        },
        "name": {
            "shortname": "ANDORRA",
            "shortnamelowercase": "Andorra",
            "fullname": "the Principality of Andorra"
        },
        "flag": {
            "spriteIcon": "ad"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AO",
            "alpha3code": "AGO",
            "numericcode": "024"
        },
        "name": {
            "shortname": "ANGOLA",
            "shortnamelowercase": "Angola",
            "fullname": "the Republic of Angola"
        },
        "flag": {
            "spriteIcon": "ao"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AI",
            "alpha3code": "AIA",
            "numericcode": "660"
        },
        "name": {
            "shortname": "ANGUILLA",
            "shortnamelowercase": "Anguilla",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ai"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AQ",
            "alpha3code": "ATA",
            "numericcode": "010"
        },
        "name": {
            "shortname": "ANTARCTICA",
            "shortnamelowercase": "Antarctica",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "aq"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AG",
            "alpha3code": "ATG",
            "numericcode": "028"
        },
        "name": {
            "shortname": "ANTIGUA AND BARBUDA",
            "shortnamelowercase": "Antigua and Barbuda",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ag"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AR",
            "alpha3code": "ARG",
            "numericcode": "032"
        },
        "name": {
            "shortname": "ARGENTINA",
            "shortnamelowercase": "Argentina",
            "fullname": "the Argentine Republic"
        },
        "flag": {
            "spriteIcon": "ar"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AM",
            "alpha3code": "ARM",
            "numericcode": "051"
        },
        "name": {
            "shortname": "ARMENIA",
            "shortnamelowercase": "Armenia",
            "fullname": "the Republic of Armenia"
        },
        "flag": {
            "spriteIcon": "am"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AW",
            "alpha3code": "ABW",
            "numericcode": "533"
        },
        "name": {
            "shortname": "ARUBA",
            "shortnamelowercase": "Aruba",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "aw"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AU",
            "alpha3code": "AUS",
            "numericcode": "036"
        },
        "name": {
            "shortname": "AUSTRALIA",
            "shortnamelowercase": "Australia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "au"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AT",
            "alpha3code": "AUT",
            "numericcode": "040"
        },
        "name": {
            "shortname": "AUSTRIA",
            "shortnamelowercase": "Austria",
            "fullname": "the Republic of Austria"
        },
        "flag": {
            "spriteIcon": "at"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AZ",
            "alpha3code": "AZE",
            "numericcode": "031"
        },
        "name": {
            "shortname": "AZERBAIJAN",
            "shortnamelowercase": "Azerbaijan",
            "fullname": "the Republic of Azerbaijan"
        },
        "flag": {
            "spriteIcon": "az"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BS",
            "alpha3code": "BHS",
            "numericcode": "044"
        },
        "name": {
            "shortname": "BAHAMAS",
            "shortnamelowercase": "Bahamas (the)",
            "fullname": "the Commonwealth of the Bahamas"
        },
        "flag": {
            "spriteIcon": "bs"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BH",
            "alpha3code": "BHR",
            "numericcode": "048"
        },
        "name": {
            "shortname": "BAHRAIN",
            "shortnamelowercase": "Bahrain",
            "fullname": "the Kingdom of Bahrain"
        },
        "flag": {
            "spriteIcon": "bh"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BD",
            "alpha3code": "BGD",
            "numericcode": "050"
        },
        "name": {
            "shortname": "BANGLADESH",
            "shortnamelowercase": "Bangladesh",
            "fullname": "the People's Republic of Bangladesh"
        },
        "flag": {
            "spriteIcon": "bd"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BB",
            "alpha3code": "BRB",
            "numericcode": "052"
        },
        "name": {
            "shortname": "BARBADOS",
            "shortnamelowercase": "Barbados",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "bb"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BY",
            "alpha3code": "BLR",
            "numericcode": "112"
        },
        "name": {
            "shortname": "BELARUS",
            "shortnamelowercase": "Belarus",
            "fullname": "the Republic of Belarus"
        },
        "flag": {
            "spriteIcon": "by"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BE",
            "alpha3code": "BEL",
            "numericcode": "056"
        },
        "name": {
            "shortname": "BELGIUM",
            "shortnamelowercase": "Belgium",
            "fullname": "the Kingdom of Belgium"
        },
        "flag": {
            "spriteIcon": "be"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BZ",
            "alpha3code": "BLZ",
            "numericcode": "084"
        },
        "name": {
            "shortname": "BELIZE",
            "shortnamelowercase": "Belize",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "bz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BJ",
            "alpha3code": "BEN",
            "numericcode": "204"
        },
        "name": {
            "shortname": "BENIN",
            "shortnamelowercase": "Benin",
            "fullname": "the Republic of Benin"
        },
        "flag": {
            "spriteIcon": "bj"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BM",
            "alpha3code": "BMU",
            "numericcode": "060"
        },
        "name": {
            "shortname": "BERMUDA",
            "shortnamelowercase": "Bermuda",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "bm"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AX",
            "alpha3code": "ALA",
            "numericcode": "248"
        },
        "name": {
            "shortname": "ÅLAND ISLANDS",
            "shortnamelowercase": "Åland Islands",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ax"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BT",
            "alpha3code": "BTN",
            "numericcode": "064"
        },
        "name": {
            "shortname": "BHUTAN",
            "shortnamelowercase": "Bhutan",
            "fullname": "the Kingdom of Bhutan"
        },
        "flag": {
            "spriteIcon": "bt"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BO",
            "alpha3code": "BOL",
            "numericcode": "068"
        },
        "name": {
            "shortname": "BOLIVIA (PLURINATIONAL STATE OF)",
            "shortnamelowercase": "Bolivia (Plurinational State of)",
            "fullname": "the Plurinational State of Bolivia"
        },
        "flag": {
            "spriteIcon": "bo"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BQ",
            "alpha3code": "BES",
            "numericcode": "535"
        },
        "name": {
            "shortname": "BONAIRE, SINT EUSTATIUS AND SABA",
            "shortnamelowercase": "Bonaire, Sint Eustatius and Saba",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "nl"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BA",
            "alpha3code": "BIH",
            "numericcode": "070"
        },
        "name": {
            "shortname": "BOSNIA AND HERZEGOVINA",
            "shortnamelowercase": "Bosnia and Herzegovina",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ba"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BW",
            "alpha3code": "BWA",
            "numericcode": "072"
        },
        "name": {
            "shortname": "BOTSWANA",
            "shortnamelowercase": "Botswana",
            "fullname": "the Republic of Botswana"
        },
        "flag": {
            "spriteIcon": "bw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BV",
            "alpha3code": "BVT",
            "numericcode": "074"
        },
        "name": {
            "shortname": "BOUVET ISLAND",
            "shortnamelowercase": "Bouvet Island",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "sj"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BR",
            "alpha3code": "BRA",
            "numericcode": "076"
        },
        "name": {
            "shortname": "BRAZIL",
            "shortnamelowercase": "Brazil",
            "fullname": "the Federative Republic of Brazil"
        },
        "flag": {
            "spriteIcon": "br"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IO",
            "alpha3code": "IOT",
            "numericcode": "086"
        },
        "name": {
            "shortname": "BRITISH INDIAN OCEAN TERRITORY",
            "shortnamelowercase": "British Indian Ocean Territory (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "io"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BN",
            "alpha3code": "BRN",
            "numericcode": "096"
        },
        "name": {
            "shortname": "BRUNEI DARUSSALAM",
            "shortnamelowercase": "Brunei Darussalam",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "bn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BG",
            "alpha3code": "BGR",
            "numericcode": "100"
        },
        "name": {
            "shortname": "BULGARIA",
            "shortnamelowercase": "Bulgaria",
            "fullname": "the Republic of Bulgaria"
        },
        "flag": {
            "spriteIcon": "bg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BF",
            "alpha3code": "BFA",
            "numericcode": "854"
        },
        "name": {
            "shortname": "BURKINA FASO",
            "shortnamelowercase": "Burkina Faso",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "bf"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BI",
            "alpha3code": "BDI",
            "numericcode": "108"
        },
        "name": {
            "shortname": "BURUNDI",
            "shortnamelowercase": "Burundi",
            "fullname": "the Republic of Burundi"
        },
        "flag": {
            "spriteIcon": "bi"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CV",
            "alpha3code": "CPV",
            "numericcode": "132"
        },
        "name": {
            "shortname": "CABO VERDE",
            "shortnamelowercase": "Cabo Verde",
            "fullname": "the Republic of Cabo Verde"
        },
        "flag": {
            "spriteIcon": "cv"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KH",
            "alpha3code": "KHM",
            "numericcode": "116"
        },
        "name": {
            "shortname": "CAMBODIA",
            "shortnamelowercase": "Cambodia",
            "fullname": "the Kingdom of Cambodia"
        },
        "flag": {
            "spriteIcon": "kh"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CM",
            "alpha3code": "CMR",
            "numericcode": "120"
        },
        "name": {
            "shortname": "CAMEROON",
            "shortnamelowercase": "Cameroon",
            "fullname": "the Republic of Cameroon"
        },
        "flag": {
            "spriteIcon": "cm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CA",
            "alpha3code": "CAN",
            "numericcode": "124"
        },
        "name": {
            "shortname": "CANADA",
            "shortnamelowercase": "Canada",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ca"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KY",
            "alpha3code": "CYM",
            "numericcode": "136"
        },
        "name": {
            "shortname": "CAYMAN ISLANDS",
            "shortnamelowercase": "Cayman Islands (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ky"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CF",
            "alpha3code": "CAF",
            "numericcode": "140"
        },
        "name": {
            "shortname": "CENTRAL AFRICAN REPUBLIC",
            "shortnamelowercase": "Central African Republic (the)",
            "fullname": "the Central African Republic"
        },
        "flag": {
            "spriteIcon": "cf"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TD",
            "alpha3code": "TCD",
            "numericcode": "148"
        },
        "name": {
            "shortname": "CHAD",
            "shortnamelowercase": "Chad",
            "fullname": "the Republic of Chad"
        },
        "flag": {
            "spriteIcon": "td"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CL",
            "alpha3code": "CHL",
            "numericcode": "152"
        },
        "name": {
            "shortname": "CHILE",
            "shortnamelowercase": "Chile",
            "fullname": "the Republic of Chile"
        },
        "flag": {
            "spriteIcon": "cl"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CN",
            "alpha3code": "CHN",
            "numericcode": "156"
        },
        "name": {
            "shortname": "CHINA",
            "shortnamelowercase": "China",
            "fullname": "the People's Republic of China"
        },
        "flag": {
            "spriteIcon": "cn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CX",
            "alpha3code": "CXR",
            "numericcode": "162"
        },
        "name": {
            "shortname": "CHRISTMAS ISLAND",
            "shortnamelowercase": "Christmas Island",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "cx"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CC",
            "alpha3code": "CCK",
            "numericcode": "166"
        },
        "name": {
            "shortname": "COCOS (KEELING) ISLANDS",
            "shortnamelowercase": "Cocos (Keeling) Islands (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "cc"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CO",
            "alpha3code": "COL",
            "numericcode": "170"
        },
        "name": {
            "shortname": "COLOMBIA",
            "shortnamelowercase": "Colombia",
            "fullname": "the Republic of Colombia"
        },
        "flag": {
            "spriteIcon": "co"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KM",
            "alpha3code": "COL",
            "numericcode": "174"
        },
        "name": {
            "shortname": "COMOROS",
            "shortnamelowercase": "Comoros (the)",
            "fullname": "the Union of the Comoros"
        },
        "flag": {
            "spriteIcon": "km"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CD",
            "alpha3code": "COD",
            "numericcode": "180"
        },
        "name": {
            "shortname": "CONGO, DEMOCRATIC REPUBLIC OF THE",
            "shortnamelowercase": "Congo (the Democratic Republic of the)",
            "fullname": "the Democratic Republic of the Congo"
        },
        "flag": {
            "spriteIcon": "cd"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CG",
            "alpha3code": "COG",
            "numericcode": "178"
        },
        "name": {
            "shortname": "CONGO",
            "shortnamelowercase": "Congo (the)",
            "fullname": "the Republic of the Congo"
        },
        "flag": {
            "spriteIcon": "cg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CK",
            "alpha3code": "COK",
            "numericcode": "184"
        },
        "name": {
            "shortname": "COOK ISLANDS",
            "shortnamelowercase": "Cook Islands (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ck"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CR",
            "alpha3code": "CRI",
            "numericcode": "188"
        },
        "name": {
            "shortname": "COSTA RICA",
            "shortnamelowercase": "Costa Rica",
            "fullname": "the Republic of Costa Rica"
        },
        "flag": {
            "spriteIcon": "cr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "HR",
            "alpha3code": "HRV",
            "numericcode": "191"
        },
        "name": {
            "shortname": "CROATIA",
            "shortnamelowercase": "Croatia",
            "fullname": "the Republic of Croatia"
        },
        "flag": {
            "spriteIcon": "hr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CU",
            "alpha3code": "CUB",
            "numericcode": "192"
        },
        "name": {
            "shortname": "CUBA",
            "shortnamelowercase": "Cuba",
            "fullname": "the Republic of Cuba"
        },
        "flag": {
            "spriteIcon": "cu"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CW",
            "alpha3code": "CUW",
            "numericcode": "531"
        },
        "name": {
            "shortname": "CURAÇAO",
            "shortnamelowercase": "Curaçao",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "cw"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CY",
            "alpha3code": "CYP",
            "numericcode": "196"
        },
        "name": {
            "shortname": "CYPRUS",
            "shortnamelowercase": "Cyprus",
            "fullname": "the Republic of Cyprus"
        },
        "flag": {
            "spriteIcon": "cy"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CZ",
            "alpha3code": "CZE",
            "numericcode": "203"
        },
        "name": {
            "shortname": "CZECHIA",
            "shortnamelowercase": "Czechia",
            "fullname": "the Czech Republic"
        },
        "flag": {
            "spriteIcon": "cz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CI",
            "alpha3code": "CIV",
            "numericcode": "384"
        },
        "name": {
            "shortname": "CÔTE D'IVOIRE",
            "shortnamelowercase": "Côte d'Ivoire",
            "fullname": "the Republic of Côte d'Ivoire"
        },
        "flag": {
            "spriteIcon": "ci"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "DK",
            "alpha3code": "DNK",
            "numericcode": "208"
        },
        "name": {
            "shortname": "DENMARK",
            "shortnamelowercase": "Denmark",
            "fullname": "the Kingdom of Denmark"
        },
        "flag": {
            "spriteIcon": "dk"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "DJ",
            "alpha3code": "DJI",
            "numericcode": "262"
        },
        "name": {
            "shortname": "DJIBOUTI",
            "shortnamelowercase": "Djibouti",
            "fullname": "the Republic of Djibouti"
        },
        "flag": {
            "spriteIcon": "dj"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "DM",
            "alpha3code": "DMA",
            "numericcode": "212"
        },
        "name": {
            "shortname": "DOMINICA",
            "shortnamelowercase": "Dominica",
            "fullname": "the Commonwealth of Dominica"
        },
        "flag": {
            "spriteIcon": "dm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "DO",
            "alpha3code": "DOM",
            "numericcode": "214"
        },
        "name": {
            "shortname": "DOMINICAN REPUBLIC",
            "shortnamelowercase": "Dominican Republic (the)",
            "fullname": "the Dominican Republic"
        },
        "flag": {
            "spriteIcon": "do"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "EC",
            "alpha3code": "ECU",
            "numericcode": "218"
        },
        "name": {
            "shortname": "ECUADOR",
            "shortnamelowercase": "Ecuador",
            "fullname": "the Republic of Ecuador"
        },
        "flag": {
            "spriteIcon": "ec"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "EG",
            "alpha3code": "EGY",
            "numericcode": "818"
        },
        "name": {
            "shortname": "EGYPT",
            "shortnamelowercase": "Egypt",
            "fullname": "the Arab Republic of Egypt"
        },
        "flag": {
            "spriteIcon": "eg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SV",
            "alpha3code": "SLV",
            "numericcode": "222"
        },
        "name": {
            "shortname": "EL SALVADOR",
            "shortnamelowercase": "El Salvador",
            "fullname": "the Republic of El Salvador"
        },
        "flag": {
            "spriteIcon": "sv"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GQ",
            "alpha3code": "GNQ",
            "numericcode": "226"
        },
        "name": {
            "shortname": "EQUATORIAL GUINEA",
            "shortnamelowercase": "Equatorial Guinea",
            "fullname": "the Republic of Equatorial Guinea"
        },
        "flag": {
            "spriteIcon": "gq"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ER",
            "alpha3code": "ERI",
            "numericcode": "232"
        },
        "name": {
            "shortname": "ERITREA",
            "shortnamelowercase": "Eritrea",
            "fullname": "the State of Eritrea"
        },
        "flag": {
            "spriteIcon": "er"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "EE",
            "alpha3code": "EST",
            "numericcode": "233"
        },
        "name": {
            "shortname": "ESTONIA",
            "shortnamelowercase": "Estonia",
            "fullname": "the Republic of Estonia"
        },
        "flag": {
            "spriteIcon": "ee"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SZ",
            "alpha3code": "SWZ",
            "numericcode": "748"
        },
        "name": {
            "shortname": "ESWATINI",
            "shortnamelowercase": "Eswatini",
            "fullname": "the Kingdom of Eswatini"
        },
        "flag": {
            "spriteIcon": "sz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ET",
            "alpha3code": "ETH",
            "numericcode": "231"
        },
        "name": {
            "shortname": "ETHIOPIA",
            "shortnamelowercase": "Ethiopia",
            "fullname": "the Federal Democratic Republic of Ethiopia"
        },
        "flag": {
            "spriteIcon": "et"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "FK",
            "alpha3code": "FLK",
            "numericcode": "238"
        },
        "name": {
            "shortname": "FALKLAND ISLANDS (MALVINAS)",
            "shortnamelowercase": "Falkland Islands (the) [Malvinas]",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fk"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "FO",
            "alpha3code": "FRO",
            "numericcode": "234"
        },
        "name": {
            "shortname": "FAROE ISLANDS",
            "shortnamelowercase": "Faroe Islands (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fo"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "FJ",
            "alpha3code": "FJI",
            "numericcode": "242"
        },
        "name": {
            "shortname": "FIJI",
            "shortnamelowercase": "Fiji",
            "fullname": "the Republic of Fiji"
        },
        "flag": {
            "spriteIcon": "fj"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "FI",
            "alpha3code": "FIN",
            "numericcode": "246"
        },
        "name": {
            "shortname": "FINLAND",
            "shortnamelowercase": "Finland",
            "fullname": "the Republic of Finland"
        },
        "flag": {
            "spriteIcon": "fi"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "FR",
            "alpha3code": "FRA",
            "numericcode": "250"
        },
        "name": {
            "shortname": "FRANCE",
            "shortnamelowercase": "France",
            "fullname": "FRANCE"
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GF",
            "alpha3code": "GUF",
            "numericcode": "254"
        },
        "name": {
            "shortname": "FRENCH GUIANA",
            "shortnamelowercase": "French Guiana",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PF",
            "alpha3code": "PYF",
            "numericcode": "258"
        },
        "name": {
            "shortname": "FRENCH POLYNESIA",
            "shortnamelowercase": "French Polynesia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "pf"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TF",
            "alpha3code": "ATF",
            "numericcode": "260"
        },
        "name": {
            "shortname": "FRENCH SOUTHERN TERRITORIES",
            "shortnamelowercase": "French Southern Territories (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "tf"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GA",
            "alpha3code": "GAB",
            "numericcode": "266"
        },
        "name": {
            "shortname": "GABON",
            "shortnamelowercase": "Gabon",
            "fullname": "the Gabonese Republic"
        },
        "flag": {
            "spriteIcon": "ga"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GM",
            "alpha3code": "GMB",
            "numericcode": "270"
        },
        "name": {
            "shortname": "GAMBIA",
            "shortnamelowercase": "Gambia (the)",
            "fullname": "the Republic of the Gambia"
        },
        "flag": {
            "spriteIcon": "gm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GE",
            "alpha3code": "GEO",
            "numericcode": "268"
        },
        "name": {
            "shortname": "GEORGIA",
            "shortnamelowercase": "Georgia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ge"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "DE",
            "alpha3code": "DEU",
            "numericcode": "276"
        },
        "name": {
            "shortname": "GERMANY",
            "shortnamelowercase": "Germany",
            "fullname": "the Federal Republic of Germany"
        },
        "flag": {
            "spriteIcon": "de"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GH",
            "alpha3code": "GHA",
            "numericcode": "288"
        },
        "name": {
            "shortname": "GHANA",
            "shortnamelowercase": "Ghana",
            "fullname": "the Republic of Ghana"
        },
        "flag": {
            "spriteIcon": "gh"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GI",
            "alpha3code": "GIB",
            "numericcode": "292"
        },
        "name": {
            "shortname": "GIBRALTAR",
            "shortnamelowercase": "Gibraltar",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gi"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GR",
            "alpha3code": "GRC",
            "numericcode": "300"
        },
        "name": {
            "shortname": "GREECE",
            "shortnamelowercase": "Greece",
            "fullname": "the Hellenic Republic"
        },
        "flag": {
            "spriteIcon": "gr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GL",
            "alpha3code": "GRL",
            "numericcode": "304"
        },
        "name": {
            "shortname": "GREENLAND",
            "shortnamelowercase": "Greenland",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gl"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GD",
            "alpha3code": "GRD",
            "numericcode": "308"
        },
        "name": {
            "shortname": "GRENADA",
            "shortnamelowercase": "Grenada",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gd"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GP",
            "alpha3code": "GLP",
            "numericcode": "312"
        },
        "name": {
            "shortname": "GUADELOUPE",
            "shortnamelowercase": "Guadeloupe",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GU",
            "alpha3code": "GUM",
            "numericcode": "316"
        },
        "name": {
            "shortname": "GUAM",
            "shortnamelowercase": "Guam",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gu"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GT",
            "alpha3code": "GTM",
            "numericcode": "320"
        },
        "name": {
            "shortname": "GUATEMALA",
            "shortnamelowercase": "Guatemala",
            "fullname": "the Republic of Guatemala"
        },
        "flag": {
            "spriteIcon": "gt"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GG",
            "alpha3code": "GGY",
            "numericcode": "831"
        },
        "name": {
            "shortname": "GUERNSEY",
            "shortnamelowercase": "Guernsey",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gg"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GN",
            "alpha3code": "GIN",
            "numericcode": "324"
        },
        "name": {
            "shortname": "GUINEA",
            "shortnamelowercase": "Guinea",
            "fullname": "the Republic of Guinea"
        },
        "flag": {
            "spriteIcon": "gn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GW",
            "alpha3code": "GNB",
            "numericcode": "624"
        },
        "name": {
            "shortname": "GUINEA-BISSAU",
            "shortnamelowercase": "Guinea-Bissau",
            "fullname": "the Republic of Guinea-Bissau"
        },
        "flag": {
            "spriteIcon": "gw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GY",
            "alpha3code": "GUY",
            "numericcode": "328"
        },
        "name": {
            "shortname": "GUYANA",
            "shortnamelowercase": "Guyana",
            "fullname": "the Co-operative Republic of Guyana"
        },
        "flag": {
            "spriteIcon": "gy"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "HT",
            "alpha3code": "HTI",
            "numericcode": "332"
        },
        "name": {
            "shortname": "HAITI",
            "shortnamelowercase": "Haiti",
            "fullname": "the Republic of Haiti"
        },
        "flag": {
            "spriteIcon": "ht"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "HM",
            "alpha3code": "HMD",
            "numericcode": "334"
        },
        "name": {
            "shortname": "HEARD ISLAND AND MCDONALD ISLANDS",
            "shortnamelowercase": "Heard Island and McDonald Islands",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "hm"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VA",
            "alpha3code": "VAT",
            "numericcode": "336"
        },
        "name": {
            "shortname": "HOLY SEE",
            "shortnamelowercase": "Holy See (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "va"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "HN",
            "alpha3code": "HND",
            "numericcode": "340"
        },
        "name": {
            "shortname": "HONDURAS",
            "shortnamelowercase": "Honduras",
            "fullname": "the Republic of Honduras"
        },
        "flag": {
            "spriteIcon": "hn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "HK",
            "alpha3code": "HKG",
            "numericcode": "344"
        },
        "name": {
            "shortname": "HONG KONG",
            "shortnamelowercase": "Hong Kong",
            "fullname": "the Hong Kong Special Administrative Region of China"
        },
        "flag": {
            "spriteIcon": "hk"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "HU",
            "alpha3code": "HUN",
            "numericcode": "348"
        },
        "name": {
            "shortname": "HUNGARY",
            "shortnamelowercase": "Hungary",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "hu"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IS",
            "alpha3code": "ISL",
            "numericcode": "352"
        },
        "name": {
            "shortname": "ICELAND",
            "shortnamelowercase": "Iceland",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "is"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IN",
            "alpha3code": "IND",
            "numericcode": "356"
        },
        "name": {
            "shortname": "INDIA",
            "shortnamelowercase": "India",
            "fullname": "the Republic of India"
        },
        "flag": {
            "spriteIcon": "in"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ID",
            "alpha3code": "IDN",
            "numericcode": "360"
        },
        "name": {
            "shortname": "INDONESIA",
            "shortnamelowercase": "Indonesia",
            "fullname": "the Republic of Indonesia"
        },
        "flag": {
            "spriteIcon": "id"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IR",
            "alpha3code": "IRN",
            "numericcode": "364"
        },
        "name": {
            "shortname": "IRAN (ISLAMIC REPUBLIC OF)",
            "shortnamelowercase": "Iran (Islamic Republic of)",
            "fullname": "the Islamic Republic of Iran"
        },
        "flag": {
            "spriteIcon": "ir"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IQ",
            "alpha3code": "IRQ",
            "numericcode": "368"
        },
        "name": {
            "shortname": "IRAQ",
            "shortnamelowercase": "Iraq",
            "fullname": "the Republic of Iraq"
        },
        "flag": {
            "spriteIcon": "iq"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IE",
            "alpha3code": "IRL",
            "numericcode": "372"
        },
        "name": {
            "shortname": "IRELAND",
            "shortnamelowercase": "Ireland",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ie"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IM",
            "alpha3code": "IMN",
            "numericcode": "833"
        },
        "name": {
            "shortname": "ISLE OF MAN",
            "shortnamelowercase": "Isle of Man",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "im"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IL",
            "alpha3code": "ISR",
            "numericcode": "376"
        },
        "name": {
            "shortname": "ISRAEL",
            "shortnamelowercase": "Israel",
            "fullname": "the State of Israel"
        },
        "flag": {
            "spriteIcon": "il"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "IT",
            "alpha3code": "ITA",
            "numericcode": "380"
        },
        "name": {
            "shortname": "ITALY",
            "shortnamelowercase": "Italy",
            "fullname": "the Republic of Italy"
        },
        "flag": {
            "spriteIcon": "it"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "JM",
            "alpha3code": "JAM",
            "numericcode": "388"
        },
        "name": {
            "shortname": "JAMAICA",
            "shortnamelowercase": "Jamaica",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "jm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "JP",
            "alpha3code": "JPN",
            "numericcode": "392"
        },
        "name": {
            "shortname": "JAPAN",
            "shortnamelowercase": "Japan",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "jp"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "JE",
            "alpha3code": "JEY",
            "numericcode": "832"
        },
        "name": {
            "shortname": "JERSEY",
            "shortnamelowercase": "Jersey",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "je"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "JO",
            "alpha3code": "JOR",
            "numericcode": "400"
        },
        "name": {
            "shortname": "JORDAN",
            "shortnamelowercase": "Jordan",
            "fullname": "the Hashemite Kingdom of Jordan"
        },
        "flag": {
            "spriteIcon": "jo"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KZ",
            "alpha3code": "KAZ",
            "numericcode": "398"
        },
        "name": {
            "shortname": "KAZAKHSTAN",
            "shortnamelowercase": "Kazakhstan",
            "fullname": "the Republic of Kazakhstan"
        },
        "flag": {
            "spriteIcon": "kz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KE",
            "alpha3code": "KEN",
            "numericcode": "404"
        },
        "name": {
            "shortname": "KENYA",
            "shortnamelowercase": "Kenya",
            "fullname": "the Republic of Kenya"
        },
        "flag": {
            "spriteIcon": "ke"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KI",
            "alpha3code": "KIR",
            "numericcode": "296"
        },
        "name": {
            "shortname": "KIRIBATI",
            "shortnamelowercase": "Kiribati",
            "fullname": "the Republic of Kiribati"
        },
        "flag": {
            "spriteIcon": "ki"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KP",
            "alpha3code": "PRK",
            "numericcode": "408"
        },
        "name": {
            "shortname": "KOREA (DEMOCRATIC PEOPLE'S REPUBLIC OF)",
            "shortnamelowercase": "Korea (the Democratic People's Republic of)",
            "fullname": "the Democratic People's Republic of Korea"
        },
        "flag": {
            "spriteIcon": "kp"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KR",
            "alpha3code": "KOR",
            "numericcode": "410"
        },
        "name": {
            "shortname": "KOREA, REPUBLIC OF",
            "shortnamelowercase": "Korea (the Republic of)",
            "fullname": "the Republic of Korea"
        },
        "flag": {
            "spriteIcon": "kr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KW",
            "alpha3code": "KWT",
            "numericcode": "414"
        },
        "name": {
            "shortname": "KUWAIT",
            "shortnamelowercase": "Kuwait",
            "fullname": "the State of Kuwait"
        },
        "flag": {
            "spriteIcon": "kw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KG",
            "alpha3code": "KGZ",
            "numericcode": "417"
        },
        "name": {
            "shortname": "KYRGYZSTAN",
            "shortnamelowercase": "Kyrgyzstan",
            "fullname": "the Kyrgyz Republic"
        },
        "flag": {
            "spriteIcon": "kg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LA",
            "alpha3code": "LAO",
            "numericcode": "418"
        },
        "name": {
            "shortname": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
            "shortnamelowercase": "Lao People's Democratic Republic (the)",
            "fullname": "the Lao People's Democratic Republic"
        },
        "flag": {
            "spriteIcon": "la"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LV",
            "alpha3code": "LVA",
            "numericcode": "428"
        },
        "name": {
            "shortname": "LATVIA",
            "shortnamelowercase": "Latvia",
            "fullname": "the Republic of Latvia"
        },
        "flag": {
            "spriteIcon": "lv"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LB",
            "alpha3code": "LBN",
            "numericcode": "422"
        },
        "name": {
            "shortname": "LEBANON",
            "shortnamelowercase": "Lebanon",
            "fullname": "the Lebanese Republic"
        },
        "flag": {
            "spriteIcon": "lb"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LS",
            "alpha3code": "LSO",
            "numericcode": "426"
        },
        "name": {
            "shortname": "LESOTHO",
            "shortnamelowercase": "Lesotho",
            "fullname": "the Kingdom of Lesotho"
        },
        "flag": {
            "spriteIcon": "ls"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LR",
            "alpha3code": "LBR",
            "numericcode": "430"
        },
        "name": {
            "shortname": "LIBERIA",
            "shortnamelowercase": "Liberia",
            "fullname": "the Republic of Liberia"
        },
        "flag": {
            "spriteIcon": "lr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LY",
            "alpha3code": "LBY",
            "numericcode": "434"
        },
        "name": {
            "shortname": "LIBYA",
            "shortnamelowercase": "Libya",
            "fullname": "the State of Libya"
        },
        "flag": {
            "spriteIcon": "ly"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LI",
            "alpha3code": "LIE",
            "numericcode": "438"
        },
        "name": {
            "shortname": "LIECHTENSTEIN",
            "shortnamelowercase": "Liechtenstein",
            "fullname": "the Principality of Liechtenstein"
        },
        "flag": {
            "spriteIcon": "li"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LT",
            "alpha3code": "LTU",
            "numericcode": "440"
        },
        "name": {
            "shortname": "LITHUANIA",
            "shortnamelowercase": "Lithuania",
            "fullname": "the Republic of Lithuania"
        },
        "flag": {
            "spriteIcon": "lt"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LU",
            "alpha3code": "LUX",
            "numericcode": "442"
        },
        "name": {
            "shortname": "LUXEMBOURG",
            "shortnamelowercase": "Luxembourg",
            "fullname": "the Grand Duchy of Luxembourg"
        },
        "flag": {
            "spriteIcon": "lu"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MO",
            "alpha3code": "MAC",
            "numericcode": "446"
        },
        "name": {
            "shortname": "MACAO",
            "shortnamelowercase": "Macao",
            "fullname": "Macao Special Administrative Region of China"
        },
        "flag": {
            "spriteIcon": "mo"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MG",
            "alpha3code": "MDG",
            "numericcode": "450"
        },
        "name": {
            "shortname": "MADAGASCAR",
            "shortnamelowercase": "Madagascar",
            "fullname": "the Republic of Madagascar"
        },
        "flag": {
            "spriteIcon": "mg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MW",
            "alpha3code": "MWI",
            "numericcode": "454"
        },
        "name": {
            "shortname": "MALAWI",
            "shortnamelowercase": "Malawi",
            "fullname": "the Republic of Malawi"
        },
        "flag": {
            "spriteIcon": "mw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MY",
            "alpha3code": "MYS",
            "numericcode": "458"
        },
        "name": {
            "shortname": "MALAYSIA",
            "shortnamelowercase": "Malaysia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "my"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MV",
            "alpha3code": "MDV",
            "numericcode": "462"
        },
        "name": {
            "shortname": "MALDIVES",
            "shortnamelowercase": "Maldives",
            "fullname": "the Republic of Maldives"
        },
        "flag": {
            "spriteIcon": "mv"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ML",
            "alpha3code": "MLI",
            "numericcode": "466"
        },
        "name": {
            "shortname": "MALI",
            "shortnamelowercase": "Mali",
            "fullname": "the Republic of Mali"
        },
        "flag": {
            "spriteIcon": "ml"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MT",
            "alpha3code": "MLT",
            "numericcode": "470"
        },
        "name": {
            "shortname": "MALTA",
            "shortnamelowercase": "Malta",
            "fullname": "the Republic of Malta"
        },
        "flag": {
            "spriteIcon": "mt"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MH",
            "alpha3code": "MHL",
            "numericcode": "584"
        },
        "name": {
            "shortname": "MARSHALL ISLANDS",
            "shortnamelowercase": "Marshall Islands (the)",
            "fullname": "the Republic of the Marshall Islands"
        },
        "flag": {
            "spriteIcon": "mh"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MQ",
            "alpha3code": "MTQ",
            "numericcode": "474"
        },
        "name": {
            "shortname": "MARTINIQUE",
            "shortnamelowercase": "Martinique",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MR",
            "alpha3code": "MRT",
            "numericcode": "478"
        },
        "name": {
            "shortname": "MAURITANIA",
            "shortnamelowercase": "Mauritania",
            "fullname": "the Islamic Republic of Mauritania"
        },
        "flag": {
            "spriteIcon": "mr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MU",
            "alpha3code": "MUS",
            "numericcode": "480"
        },
        "name": {
            "shortname": "MAURITIUS",
            "shortnamelowercase": "Mauritius",
            "fullname": "the Republic of Mauritius"
        },
        "flag": {
            "spriteIcon": "mu"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "YT",
            "alpha3code": "MYT",
            "numericcode": "175"
        },
        "name": {
            "shortname": "MAYOTTE",
            "shortnamelowercase": "Mayotte",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MX",
            "alpha3code": "MEX",
            "numericcode": "484"
        },
        "name": {
            "shortname": "MEXICO",
            "shortnamelowercase": "Mexico",
            "fullname": "the United Mexican States"
        },
        "flag": {
            "spriteIcon": "mx"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "FM",
            "alpha3code": "FSM",
            "numericcode": "583"
        },
        "name": {
            "shortname": "MICRONESIA (FEDERATED STATES OF)",
            "shortnamelowercase": "Micronesia (Federated States of)",
            "fullname": "the Federated States of Micronesia"
        },
        "flag": {
            "spriteIcon": "fm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MD",
            "alpha3code": "MDA",
            "numericcode": "498"
        },
        "name": {
            "shortname": "MOLDOVA, REPUBLIC OF",
            "shortnamelowercase": "Moldova (the Republic of)",
            "fullname": "the Republic of Moldova"
        },
        "flag": {
            "spriteIcon": "md"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MC",
            "alpha3code": "MCO",
            "numericcode": "492"
        },
        "name": {
            "shortname": "MONACO",
            "shortnamelowercase": "Monaco",
            "fullname": "the Principality of Monaco"
        },
        "flag": {
            "spriteIcon": "mc"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MN",
            "alpha3code": "MNG",
            "numericcode": "496"
        },
        "name": {
            "shortname": "MONGOLIA",
            "shortnamelowercase": "Mongolia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "mn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ME",
            "alpha3code": "MNE",
            "numericcode": "499"
        },
        "name": {
            "shortname": "MONTENEGRO",
            "shortnamelowercase": "Montenegro",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "me"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MS",
            "alpha3code": "MSR",
            "numericcode": "500"
        },
        "name": {
            "shortname": "MONTSERRAT",
            "shortnamelowercase": "Montserrat",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ms"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MA",
            "alpha3code": "MAR",
            "numericcode": "504"
        },
        "name": {
            "shortname": "MOROCCO",
            "shortnamelowercase": "Morocco",
            "fullname": "the Kingdom of Morocco"
        },
        "flag": {
            "spriteIcon": "ma"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MZ",
            "alpha3code": "MOZ",
            "numericcode": "508"
        },
        "name": {
            "shortname": "MOZAMBIQUE",
            "shortnamelowercase": "Mozambique",
            "fullname": "the Republic of Mozambique"
        },
        "flag": {
            "spriteIcon": "mz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MM",
            "alpha3code": "MMR",
            "numericcode": "104"
        },
        "name": {
            "shortname": "MYANMAR",
            "shortnamelowercase": "Myanmar",
            "fullname": "the Republic of the Union of Myanmar"
        },
        "flag": {
            "spriteIcon": "mm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NA",
            "alpha3code": "NAM",
            "numericcode": "516"
        },
        "name": {
            "shortname": "NAMIBIA",
            "shortnamelowercase": "Namibia",
            "fullname": "the Republic of Namibia"
        },
        "flag": {
            "spriteIcon": "na"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NR",
            "alpha3code": "NRU",
            "numericcode": "520"
        },
        "name": {
            "shortname": "NAURU",
            "shortnamelowercase": "Nauru",
            "fullname": "the Republic of Nauru"
        },
        "flag": {
            "spriteIcon": "nr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NP",
            "alpha3code": "NPL",
            "numericcode": "524"
        },
        "name": {
            "shortname": "NEPAL",
            "shortnamelowercase": "Nepal",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "np"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NL",
            "alpha3code": "NLD",
            "numericcode": "528"
        },
        "name": {
            "shortname": "NETHERLANDS, KINGDOM OF THE",
            "shortnamelowercase": "Netherlands (Kingdom of the)",
            "fullname": "the Kingdom of the Netherlands"
        },
        "flag": {
            "spriteIcon": "nl"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NC",
            "alpha3code": "NCL",
            "numericcode": "540"
        },
        "name": {
            "shortname": "NEW CALEDONIA",
            "shortnamelowercase": "New Caledonia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "nc"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NZ",
            "alpha3code": "NZL",
            "numericcode": "554"
        },
        "name": {
            "shortname": "NEW ZEALAND",
            "shortnamelowercase": "New Zealand",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "nz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NI",
            "alpha3code": "NIC",
            "numericcode": "558"
        },
        "name": {
            "shortname": "NICARAGUA",
            "shortnamelowercase": "Nicaragua",
            "fullname": "the Republic of Nicaragua"
        },
        "flag": {
            "spriteIcon": "ni"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NE",
            "alpha3code": "NER",
            "numericcode": "562"
        },
        "name": {
            "shortname": "NIGER",
            "shortnamelowercase": "Niger (the)",
            "fullname": "the Republic of the Niger"
        },
        "flag": {
            "spriteIcon": "ne"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NG",
            "alpha3code": "NGA",
            "numericcode": "566"
        },
        "name": {
            "shortname": "NIGERIA",
            "shortnamelowercase": "Nigeria",
            "fullname": "the Federal Republic of Nigeria"
        },
        "flag": {
            "spriteIcon": "ng"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NU",
            "alpha3code": "NIU",
            "numericcode": "570"
        },
        "name": {
            "shortname": "NIUE",
            "shortnamelowercase": "Niue",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "nu"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NF",
            "alpha3code": "NFK",
            "numericcode": "574"
        },
        "name": {
            "shortname": "NORFOLK ISLAND",
            "shortnamelowercase": "Norfolk Island",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "nf"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MK",
            "alpha3code": "MKD",
            "numericcode": "807"
        },
        "name": {
            "shortname": "NORTH MACEDONIA",
            "shortnamelowercase": "North Macedonia",
            "fullname": "the Republic of North Macedonia"
        },
        "flag": {
            "spriteIcon": "mk"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MP",
            "alpha3code": "MNP",
            "numericcode": "580"
        },
        "name": {
            "shortname": "NORTHERN MARIANA ISLANDS",
            "shortnamelowercase": "Northern Mariana Islands (the)",
            "fullname": "the Commonwealth of the Northern Mariana Islands"
        },
        "flag": {
            "spriteIcon": "mp"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "NO",
            "alpha3code": "MNP",
            "numericcode": "578"
        },
        "name": {
            "shortname": "NORWAY",
            "shortnamelowercase": "Norway",
            "fullname": "the Kingdom of Norway"
        },
        "flag": {
            "spriteIcon": "no"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "OM",
            "alpha3code": "OMN",
            "numericcode": "512"
        },
        "name": {
            "shortname": "OMAN",
            "shortnamelowercase": "Oman",
            "fullname": "the Sultanate of Oman"
        },
        "flag": {
            "spriteIcon": "om"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PK",
            "alpha3code": "PAK",
            "numericcode": "586"
        },
        "name": {
            "shortname": "PAKISTAN",
            "shortnamelowercase": "Pakistan",
            "fullname": "the Islamic Republic of Pakistan"
        },
        "flag": {
            "spriteIcon": "pk"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PW",
            "alpha3code": "PLW",
            "numericcode": "585"
        },
        "name": {
            "shortname": "PALAU",
            "shortnamelowercase": "Palau",
            "fullname": "the Republic of Palau"
        },
        "flag": {
            "spriteIcon": "pw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PS",
            "alpha3code": "PSE",
            "numericcode": "275"
        },
        "name": {
            "shortname": "PALESTINE, STATE OF",
            "shortnamelowercase": "Palestine, State of",
            "fullname": "the State of Palestine"
        },
        "flag": {
            "spriteIcon": "ps"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PA",
            "alpha3code": "PAN",
            "numericcode": "591"
        },
        "name": {
            "shortname": "PANAMA",
            "shortnamelowercase": "Panama",
            "fullname": "the Republic of Panama"
        },
        "flag": {
            "spriteIcon": "pa"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PG",
            "alpha3code": "PNG",
            "numericcode": "598"
        },
        "name": {
            "shortname": "PAPUA NEW GUINEA",
            "shortnamelowercase": "Papua New Guinea",
            "fullname": "the Independent State of Papua New Guinea"
        },
        "flag": {
            "spriteIcon": "pg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PY",
            "alpha3code": "PRY",
            "numericcode": "600"
        },
        "name": {
            "shortname": "PARAGUAY",
            "shortnamelowercase": "Paraguay",
            "fullname": "the Republic of Paraguay"
        },
        "flag": {
            "spriteIcon": "py"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PE",
            "alpha3code": "PER",
            "numericcode": "604"
        },
        "name": {
            "shortname": "PERU",
            "shortnamelowercase": "Peru",
            "fullname": "the Republic of Peru"
        },
        "flag": {
            "spriteIcon": "pe"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PH",
            "alpha3code": "PHL",
            "numericcode": "608"
        },
        "name": {
            "shortname": "PHILIPPINES",
            "shortnamelowercase": "Philippines (the)",
            "fullname": "PHILIPPINES"
        },
        "flag": {
            "spriteIcon": "ph"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PN",
            "alpha3code": "PCN",
            "numericcode": "612"
        },
        "name": {
            "shortname": "PITCAIRN",
            "shortnamelowercase": "Pitcairn",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "pn"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PL",
            "alpha3code": "POL",
            "numericcode": "616"
        },
        "name": {
            "shortname": "POLAND",
            "shortnamelowercase": "Poland",
            "fullname": "the Republic of Poland"
        },
        "flag": {
            "spriteIcon": "pl"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PT",
            "alpha3code": "PRT",
            "numericcode": "620"
        },
        "name": {
            "shortname": "PORTUGAL",
            "shortnamelowercase": "Portugal",
            "fullname": "the Portuguese Republic"
        },
        "flag": {
            "spriteIcon": "pt"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PR",
            "alpha3code": "PRI",
            "numericcode": "630"
        },
        "name": {
            "shortname": "PUERTO RICO",
            "shortnamelowercase": "Puerto Rico",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "pr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "QA",
            "alpha3code": "QAT",
            "numericcode": "634"
        },
        "name": {
            "shortname": "QATAR",
            "shortnamelowercase": "Qatar",
            "fullname": "the State of Qatar"
        },
        "flag": {
            "spriteIcon": "qa"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "RO",
            "alpha3code": "ROU",
            "numericcode": "642"
        },
        "name": {
            "shortname": "ROMANIA",
            "shortnamelowercase": "Romania",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ro"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "RU",
            "alpha3code": "RUS",
            "numericcode": "643"
        },
        "name": {
            "shortname": "RUSSIAN FEDERATION",
            "shortnamelowercase": "Russian Federation (the)",
            "fullname": "the Russian Federation"
        },
        "flag": {
            "spriteIcon": "ru"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "RW",
            "alpha3code": "RWA",
            "numericcode": "646"
        },
        "name": {
            "shortname": "RWANDA",
            "shortnamelowercase": "Rwanda",
            "fullname": "the Republic of Rwanda"
        },
        "flag": {
            "spriteIcon": "rw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "RE",
            "alpha3code": "REU",
            "numericcode": "638"
        },
        "name": {
            "shortname": "RÉUNION",
            "shortnamelowercase": "Réunion",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "BL",
            "alpha3code": "BLM",
            "numericcode": "652"
        },
        "name": {
            "shortname": "SAINT BARTHÉLEMY",
            "shortnamelowercase": "Saint Barthélemy",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SH",
            "alpha3code": "SHN",
            "numericcode": "654"
        },
        "name": {
            "shortname": "SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA",
            "shortnamelowercase": "Saint Helena, Ascension and Tristan da Cunha",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gb"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "KN",
            "alpha3code": "KNA",
            "numericcode": "659"
        },
        "name": {
            "shortname": "SAINT KITTS AND NEVIS",
            "shortnamelowercase": "Saint Kitts and Nevis",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "kn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LC",
            "alpha3code": "LCA",
            "numericcode": "662"
        },
        "name": {
            "shortname": "SAINT LUCIA",
            "shortnamelowercase": "Saint Lucia",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "lc"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "MF",
            "alpha3code": "MAF",
            "numericcode": "663"
        },
        "name": {
            "shortname": "SAINT MARTIN (FRENCH PART)",
            "shortnamelowercase": "Saint Martin (French part)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "PM",
            "alpha3code": "SPM",
            "numericcode": "666"
        },
        "name": {
            "shortname": "SAINT PIERRE AND MIQUELON",
            "shortnamelowercase": "Saint Pierre and Miquelon",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "fr"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VC",
            "alpha3code": "VCT",
            "numericcode": "670"
        },
        "name": {
            "shortname": "SAINT VINCENT AND THE GRENADINES",
            "shortnamelowercase": "Saint Vincent and the Grenadines",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "vc"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "WS",
            "alpha3code": "WSM",
            "numericcode": "882"
        },
        "name": {
            "shortname": "SAMOA",
            "shortnamelowercase": "Samoa",
            "fullname": "the Independent State of Samoa"
        },
        "flag": {
            "spriteIcon": "ws"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SM",
            "alpha3code": "SMR",
            "numericcode": "674"
        },
        "name": {
            "shortname": "SAN MARINO",
            "shortnamelowercase": "San Marino",
            "fullname": "the Republic of San Marino"
        },
        "flag": {
            "spriteIcon": "sm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ST",
            "alpha3code": "STP",
            "numericcode": "678"
        },
        "name": {
            "shortname": "SAO TOME AND PRINCIPE",
            "shortnamelowercase": "Sao Tome and Principe",
            "fullname": "the Democratic Republic of Sao Tome and Principe"
        },
        "flag": {
            "spriteIcon": "st"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SA",
            "alpha3code": "SAU",
            "numericcode": "682"
        },
        "name": {
            "shortname": "SAUDI ARABIA",
            "shortnamelowercase": "Saudi Arabia",
            "fullname": "the Kingdom of Saudi Arabia"
        },
        "flag": {
            "spriteIcon": "sa"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SN",
            "alpha3code": "SAU",
            "numericcode": "686"
        },
        "name": {
            "shortname": "SENEGAL",
            "shortnamelowercase": "Senegal",
            "fullname": "the Republic of Senegal"
        },
        "flag": {
            "spriteIcon": "sn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "RS",
            "alpha3code": "SRB",
            "numericcode": "688"
        },
        "name": {
            "shortname": "SERBIA",
            "shortnamelowercase": "Serbia",
            "fullname": "the Republic of Serbia"
        },
        "flag": {
            "spriteIcon": "rs"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SC",
            "alpha3code": "SYC",
            "numericcode": "690"
        },
        "name": {
            "shortname": "SEYCHELLES",
            "shortnamelowercase": "Seychelles",
            "fullname": "the Republic of Seychelles"
        },
        "flag": {
            "spriteIcon": "sc"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SL",
            "alpha3code": "SLE",
            "numericcode": "694"
        },
        "name": {
            "shortname": "SIERRA LEONE",
            "shortnamelowercase": "Sierra Leone",
            "fullname": "the Republic of Sierra Leone"
        },
        "flag": {
            "spriteIcon": "sl"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SG",
            "alpha3code": "SGP",
            "numericcode": "702"
        },
        "name": {
            "shortname": "SINGAPORE",
            "shortnamelowercase": "Singapore",
            "fullname": "the Republic of Singapore"
        },
        "flag": {
            "spriteIcon": "sg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SX",
            "alpha3code": "SXM",
            "numericcode": "534"
        },
        "name": {
            "shortname": "SINT MAARTEN (DUTCH PART)",
            "shortnamelowercase": "Sint Maarten (Dutch part)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "sx"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SK",
            "alpha3code": "SVK",
            "numericcode": "703"
        },
        "name": {
            "shortname": "SLOVAKIA",
            "shortnamelowercase": "Slovakia",
            "fullname": "the Slovak Republic"
        },
        "flag": {
            "spriteIcon": "sk"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SI",
            "alpha3code": "SVN",
            "numericcode": "705"
        },
        "name": {
            "shortname": "SLOVENIA",
            "shortnamelowercase": "Slovenia",
            "fullname": "the Republic of Slovenia"
        },
        "flag": {
            "spriteIcon": "si"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SB",
            "alpha3code": "SLB",
            "numericcode": "090"
        },
        "name": {
            "shortname": "SOLOMON ISLANDS",
            "shortnamelowercase": "Solomon Islands",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "sb"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SO",
            "alpha3code": "SOM",
            "numericcode": "706"
        },
        "name": {
            "shortname": "SOMALIA",
            "shortnamelowercase": "Somalia",
            "fullname": "the Federal Republic of Somalia"
        },
        "flag": {
            "spriteIcon": "so"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ZA",
            "alpha3code": "ZAF",
            "numericcode": "710"
        },
        "name": {
            "shortname": "SOUTH AFRICA",
            "shortnamelowercase": "South Africa",
            "fullname": "the Republic of South Africa"
        },
        "flag": {
            "spriteIcon": "za"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GS",
            "alpha3code": "SGS",
            "numericcode": "239"
        },
        "name": {
            "shortname": "SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS",
            "shortnamelowercase": "South Georgia and the South Sandwich Islands",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "gs"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SS",
            "alpha3code": "SSD",
            "numericcode": "728"
        },
        "name": {
            "shortname": "SOUTH SUDAN",
            "shortnamelowercase": "South Sudan",
            "fullname": "the Republic of South Sudan"
        },
        "flag": {
            "spriteIcon": "ss"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ES",
            "alpha3code": "ESP",
            "numericcode": "724"
        },
        "name": {
            "shortname": "SPAIN",
            "shortnamelowercase": "Spain",
            "fullname": "the Kingdom of Spain"
        },
        "flag": {
            "spriteIcon": "ea"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "LK",
            "alpha3code": "LKA",
            "numericcode": "144"
        },
        "name": {
            "shortname": "SRI LANKA",
            "shortnamelowercase": "Sri Lanka",
            "fullname": "the Democratic Socialist Republic of Sri Lanka"
        },
        "flag": {
            "spriteIcon": "lk"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SD",
            "alpha3code": "SDN",
            "numericcode": "729"
        },
        "name": {
            "shortname": "SUDAN",
            "shortnamelowercase": "Sudan (the)",
            "fullname": "the Republic of the Sudan"
        },
        "flag": {
            "spriteIcon": "sd"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SR",
            "alpha3code": "SUR",
            "numericcode": "740"
        },
        "name": {
            "shortname": "SURINAME",
            "shortnamelowercase": "Suriname",
            "fullname": "the Republic of Suriname"
        },
        "flag": {
            "spriteIcon": "sr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SJ",
            "alpha3code": "SJM",
            "numericcode": "744"
        },
        "name": {
            "shortname": "SVALBARD AND JAN MAYEN",
            "shortnamelowercase": "Svalbard and Jan Mayen",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "sj"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SE",
            "alpha3code": "SWE",
            "numericcode": "752"
        },
        "name": {
            "shortname": "SWEDEN",
            "shortnamelowercase": "Sweden",
            "fullname": "the Kingdom of Sweden"
        },
        "flag": {
            "spriteIcon": "se"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "CH",
            "alpha3code": "CHE",
            "numericcode": "756"
        },
        "name": {
            "shortname": "SWITZERLAND",
            "shortnamelowercase": "Switzerland",
            "fullname": "the Swiss Confederation"
        },
        "flag": {
            "spriteIcon": "ch"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "SY",
            "alpha3code": "SYR",
            "numericcode": "760"
        },
        "name": {
            "shortname": "SYRIAN ARAB REPUBLIC",
            "shortnamelowercase": "Syrian Arab Republic (the)",
            "fullname": "the Syrian Arab Republic"
        },
        "flag": {
            "spriteIcon": "sy"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TW",
            "alpha3code": "TWN",
            "numericcode": "158"
        },
        "name": {
            "shortname": "TAIWAN, PROVINCE OF CHINA",
            "shortnamelowercase": "Taiwan (Province of China)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "tw"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TJ",
            "alpha3code": "TJK",
            "numericcode": "762"
        },
        "name": {
            "shortname": "TAJIKISTAN",
            "shortnamelowercase": "Tajikistan",
            "fullname": "the Republic of Tajikistan"
        },
        "flag": {
            "spriteIcon": "tj"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TZ",
            "alpha3code": "TZA",
            "numericcode": "834"
        },
        "name": {
            "shortname": "TANZANIA, UNITED REPUBLIC OF",
            "shortnamelowercase": "Tanzania, the United Republic of",
            "fullname": "the United Republic of Tanzania"
        },
        "flag": {
            "spriteIcon": "tz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TH",
            "alpha3code": "THA",
            "numericcode": "764"
        },
        "name": {
            "shortname": "THAILAND",
            "shortnamelowercase": "Thailand",
            "fullname": "the Kingdom of Thailand"
        },
        "flag": {
            "spriteIcon": "th"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TL",
            "alpha3code": "TLS",
            "numericcode": "626"
        },
        "name": {
            "shortname": "TIMOR-LESTE",
            "shortnamelowercase": "Timor-Leste",
            "fullname": "the Democratic Republic of Timor-Leste"
        },
        "flag": {
            "spriteIcon": "tl"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TG",
            "alpha3code": "TGO",
            "numericcode": "768"
        },
        "name": {
            "shortname": "TOGO",
            "shortnamelowercase": "Togo",
            "fullname": "the Togolese Republic"
        },
        "flag": {
            "spriteIcon": "tg"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TK",
            "alpha3code": "TKL",
            "numericcode": "772"
        },
        "name": {
            "shortname": "TOKELAU",
            "shortnamelowercase": "Tokelau",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "tk"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TO",
            "alpha3code": "TON",
            "numericcode": "776"
        },
        "name": {
            "shortname": "TONGA",
            "shortnamelowercase": "Tonga",
            "fullname": "the Kingdom of Tonga"
        },
        "flag": {
            "spriteIcon": "to"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TT",
            "alpha3code": "TTO",
            "numericcode": "780"
        },
        "name": {
            "shortname": "TRINIDAD AND TOBAGO",
            "shortnamelowercase": "Trinidad and Tobago",
            "fullname": "the Republic of Trinidad and Tobago"
        },
        "flag": {
            "spriteIcon": "tt"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TN",
            "alpha3code": "TUN",
            "numericcode": "788"
        },
        "name": {
            "shortname": "TUNISIA",
            "shortnamelowercase": "Tunisia",
            "fullname": "the Republic of Tunisia"
        },
        "flag": {
            "spriteIcon": "tn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TM",
            "alpha3code": "TKM",
            "numericcode": "795"
        },
        "name": {
            "shortname": "TURKMENISTAN",
            "shortnamelowercase": "Turkmenistan",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "tm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TC",
            "alpha3code": "TCA",
            "numericcode": "796"
        },
        "name": {
            "shortname": "TURKS AND CAICOS ISLANDS",
            "shortnamelowercase": "Turks and Caicos Islands (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "tc"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TV",
            "alpha3code": "TUV",
            "numericcode": "798"
        },
        "name": {
            "shortname": "TUVALU",
            "shortnamelowercase": "Tuvalu",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "tv"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "TR",
            "alpha3code": "TUR",
            "numericcode": "792"
        },
        "name": {
            "shortname": "TÜRKİYE",
            "shortnamelowercase": "Türkiye",
            "fullname": "the Republic of Türkiye"
        },
        "flag": {
            "spriteIcon": "tr"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "UG",
            "alpha3code": "UGA",
            "numericcode": "800"
        },
        "name": {
            "shortname": "UGANDA",
            "shortnamelowercase": "Uganda",
            "fullname": "the Republic of Uganda"
        },
        "flag": {
            "spriteIcon": "ug"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "UA",
            "alpha3code": "UKR",
            "numericcode": "804"
        },
        "name": {
            "shortname": "UKRAINE",
            "shortnamelowercase": "Ukraine",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "ua"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "AE",
            "alpha3code": "ARE",
            "numericcode": "784"
        },
        "name": {
            "shortname": "UNITED ARAB EMIRATES",
            "shortnamelowercase": "United Arab Emirates (the)",
            "fullname": "the United Arab Emirates"
        },
        "flag": {
            "spriteIcon": "ae"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "GB",
            "alpha3code": "GBR",
            "numericcode": "826"
        },
        "name": {
            "shortname": "UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND",
            "shortnamelowercase": "United Kingdom of Great Britain and Northern Ireland (the)",
            "fullname": "the United Kingdom of Great Britain and Northern Ireland"
        },
        "flag": {
            "spriteIcon": "gb"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "UM",
            "alpha3code": "UMI",
            "numericcode": "581"
        },
        "name": {
            "shortname": "UNITED STATES MINOR OUTLYING ISLANDS",
            "shortnamelowercase": "United States Minor Outlying Islands (the)",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "us"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "US",
            "alpha3code": "USA",
            "numericcode": "840"
        },
        "name": {
            "shortname": "UNITED STATES OF AMERICA",
            "shortnamelowercase": "United States of America (the)",
            "fullname": "the United States of America"
        },
        "flag": {
            "spriteIcon": "um"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "UY",
            "alpha3code": "URY",
            "numericcode": "858"
        },
        "name": {
            "shortname": "URUGUAY",
            "shortnamelowercase": "Uruguay",
            "fullname": "the Eastern Republic of Uruguay"
        },
        "flag": {
            "spriteIcon": "uy"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "UZ",
            "alpha3code": "UZB",
            "numericcode": "860"
        },
        "name": {
            "shortname": "UZBEKISTAN",
            "shortnamelowercase": "Uzbekistan",
            "fullname": "the Republic of Uzbekistan"
        },
        "flag": {
            "spriteIcon": "uz"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VU",
            "alpha3code": "VUT",
            "numericcode": "548"
        },
        "name": {
            "shortname": "VANUATU",
            "shortnamelowercase": "Vanuatu",
            "fullname": "the Republic of Vanuatu"
        },
        "flag": {
            "spriteIcon": "vu"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VE",
            "alpha3code": "VEN",
            "numericcode": "862"
        },
        "name": {
            "shortname": "VENEZUELA (BOLIVARIAN REPUBLIC OF)",
            "shortnamelowercase": "Venezuela (Bolivarian Republic of)",
            "fullname": "the Bolivarian Republic of Venezuela"
        },
        "flag": {
            "spriteIcon": "ve"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VN",
            "alpha3code": "VNM",
            "numericcode": "704"
        },
        "name": {
            "shortname": "VIET NAM",
            "shortnamelowercase": "Viet Nam",
            "fullname": "the Socialist Republic of Viet Nam"
        },
        "flag": {
            "spriteIcon": "vn"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VG",
            "alpha3code": "VGB",
            "numericcode": "092"
        },
        "name": {
            "shortname": "VIRGIN ISLANDS (BRITISH)",
            "shortnamelowercase": "Virgin Islands (British)",
            "fullname": "British Virgin Islands (the)"
        },
        "flag": {
            "spriteIcon": "vg"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "VI",
            "alpha3code": "VIR",
            "numericcode": "850"
        },
        "name": {
            "shortname": "VIRGIN ISLANDS (U.S.)",
            "shortnamelowercase": "Virgin Islands (U.S.)",
            "fullname": "the Virgin Islands of the United States"
        },
        "flag": {
            "spriteIcon": "vi"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "WF",
            "alpha3code": "WLF",
            "numericcode": "876"
        },
        "name": {
            "shortname": "WALLIS AND FUTUNA",
            "shortnamelowercase": "Wallis and Futuna",
            "fullname": "Wallis and Futuna Islands"
        },
        "flag": {
            "spriteIcon": "wf"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "EH",
            "alpha3code": "ESH",
            "numericcode": "732"
        },
        "name": {
            "shortname": "WESTERN SAHARA *",
            "shortnamelowercase": "Western Sahara *",
            "fullname": null
        },
        "flag": {
            "spriteIcon": "eh"
        },
        "independent": false,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "YE",
            "alpha3code": "YEM",
            "numericcode": "887"
        },
        "name": {
            "shortname": "YEMEN",
            "shortnamelowercase": "Yemen",
            "fullname": "the Republic of Yemen"
        },
        "flag": {
            "spriteIcon": "ye"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ZM",
            "alpha3code": "ZMB",
            "numericcode": "894"
        },
        "name": {
            "shortname": "ZAMBIA",
            "shortnamelowercase": "Zambia",
            "fullname": "the Republic of Zambia"
        },
        "flag": {
            "spriteIcon": "zm"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    },
    {
        "code": {
            "aplha2code": "ZW",
            "alpha3code": "ZWE",
            "numericcode": "716"
        },
        "name": {
            "shortname": "ZIMBABWE",
            "shortnamelowercase": "Zimbabwe",
            "fullname": "the Republic of Zimbabwe"
        },
        "flag": {
            "spriteIcon": "zw"
        },
        "independent": true,
        "administrativelanguages": [],
        "subdivisions": []
    }
]

